import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5tcn5zra86: FaireBrandEntity = {
  token: "b_5tcn5zra86",
  type: "brand",
  name: "Camellia",
  avatarUrl:
    "https://cdn.faire.com/fastly/e779ff1e6d28b0891d22423fab4535764f36c258f3ca89a14546b42f0ee593d6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c44c8754e4bf88b5f8bc1d0a18d518a4685a82f3773fd8f5d2b60c156896f9d6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e779ff1e6d28b0891d22423fab4535764f36c258f3ca89a14546b42f0ee593d6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c44c8754e4bf88b5f8bc1d0a18d518a4685a82f3773fd8f5d2b60c156896f9d6.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 91,
  isTopShop: true,
  isInsider: true,
  description:
    "Camellia is a contemporary wholesale clothing brand located in Downtown Los Angeles. We were created to make trendy designs and affordably priced yet high-quality clothes for women all over the world.\nCamellia is an elevated contemporary line of women’s clothing that merges modern designs and effortless luxury to produce timeless wardrobe staples and statement pieces. Our ultimate goal is to enable women from all walks of life to express their individuality through fashion.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:35.541Z",
    importedBy: "entity-db-cli",
  },
};
